import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_ADMIN_LOCAL_API_REQUESTS } from './constants';

export const getAdminRenologPricing = async () => {
  const apiPath = `legacy_admin/renolog/pricing`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    isLocalApiRequest: RENOLOG_ADMIN_LOCAL_API_REQUESTS,
  });

  const response = await axios(signedRequest);
  return response.data;
};
